export const slideUp = (el: HTMLElement, duration: number = 300) => {
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.boxSizing = "border-box";
  el.style.height = el.offsetHeight + "px";

  el.style.overflow = "hidden";
  el.style.height = "0";
  el.style.paddingTop = "0";
  el.style.paddingBottom = "0";
  el.style.marginTop = "0";
  el.style.marginBottom = "0";

  window.setTimeout(function () {
    el.style.display = "none";
    el.style.removeProperty("height");
    el.style.removeProperty("padding-top");
    el.style.removeProperty("padding-bottom");
    el.style.removeProperty("margin-top");
    el.style.removeProperty("margin-bottom");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
  }, duration);
};

export const slideDown = (
  el: HTMLElement,
  duration: number = 300,
  desiredDisplay = "block",
) => {
  const elDisplay = window.getComputedStyle(el).display;
  let display = elDisplay === "none" ? desiredDisplay : elDisplay;

  el.style.removeProperty("display");
  el.style.display = display;

  const height = el.offsetHeight;

  el.style.overflow = "hidden";
  el.style.height = "0";
  el.style.paddingTop = "0";
  el.style.paddingBottom = "0";
  el.style.marginTop = "0";
  el.offsetHeight;
  el.style.marginBottom = "0";
  el.style.boxSizing = "border-box";
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.height = height + "px";
  el.style.removeProperty("padding-top");
  el.style.removeProperty("padding-bottom");
  el.style.removeProperty("margin-top");
  el.style.removeProperty("margin-bottom");

  window.setTimeout(function () {
    el.style.removeProperty("height");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
  }, duration);
};
